module.exports = __webpack_public_path__ + "a6d1c71bcd5d2600a2ce8dbaeb8af51b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-steve-01.jpg
 ** module id = 371
 ** module chunks = 0
 **/